export default __webpack_public_path__ + "static/media/review_top_bg.fe7ea5d0.png";